import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { SIPCallPanel } from 'features/SIPTelephony';
import { Modal } from 'features/Modals';
import { getFormattedCountLabel } from '@web-chat-core/ui-kit';
import { selectParticipants } from 'state/selectors';
import { ShareLink } from './components/ShareLink/ShareLink';
import { ParticipantList } from './ParticipantList';
import { ParticipantModalFooterRow } from './view';

export const ParticipantsModal = observer(() => {
    const { t } = useTranslation();
    const participants = selectParticipants();
    const participantsCount = participants.length;

    return (
        <Modal
            footer={
                <ParticipantModalFooterRow>
                    <ShareLink />
                    <SIPCallPanel />
                </ParticipantModalFooterRow>
            }
            header={
                <>
                    {participantsCount}{' '}
                    {getFormattedCountLabel(participantsCount, {
                        many: t('web_call_many_members'),
                        one: t('web_call_some_one_members'),
                        some: t('web_call_some_members'),
                    })}
                </>
            }
        >
            <ParticipantList participants={participants} />
        </Modal>
    );
});
